

export default [
  {
    path: '/subject-activities',
    name: 'subject-activity',
    meta: { requiresAuth: true },
    component: () => import('@/pages/subject-activity/index.vue'),
  }
]
